<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="300"
      offset-x
    >
      <template v-slot:activator="{ on, attrs }">
        <v-avatar class="ml-3" dark v-bind="attrs" v-on="on">
          <img src="../assets/workout.png" alt="workout" />
        </v-avatar>
      </template>

      <v-card>
        <v-list>
          <v-list-item two-line>
            <v-list-item-avatar>
              <img src="../assets/workout.png" alt="workout" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title
                >{{ $store.state.user.userData.nickname }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $store.state.user.userData.firstName }}
                {{ $store.state.user.userData.name }}</v-list-item-subtitle
              >
            </v-list-item-content></v-list-item
          >
          <v-list-item>
            <v-list-item-subtitle
              >Membre depuis : {{ creationDate }}</v-list-item-subtitle
            >
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-dialog v-model="dialog" fullscreen max-width="400px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="#2837bf" text v-bind="attrs" v-on="on">
                    Modifier le profil
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline mx-auto">Modifier le profil</span>
                  </v-card-title>
                  <v-divider></v-divider>

                  <v-container class="my-6">
                    <v-row justify="center">
                      <v-col cols="11" md="8" align="center">
                        <v-text-field
                          class="my-2"
                          label="Prénom"
                          v-model="firstName"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          class="my-2"
                          label="Nom"
                          v-model="name"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          class="my-2"
                          label="Pseudonyme"
                          v-model="nickname"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          class="my-2"
                          label="Email"
                          v-model="email"
                          disabled
                          outlined
                        ></v-text-field>
                        <v-avatar size="64"
                          ><img src="../assets/workout.png"
                        /></v-avatar>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-divider></v-divider>
                  <v-container>
                    <v-row justify="end">
                      <v-col cols="12" md="4" align="end">
                        <v-btn text @click="modifyProfile" :loading="loading"
                          >Sauvegarder</v-btn
                        >
                        <v-btn text color="error" @click="cancelModifications"
                          >Annuler</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card>
              </v-dialog>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>

          <LogOutButton v-if="$store.getters.isUserLoggedIn" />
        </v-card-actions>
      </v-card>
    </v-menu>
    <v-snackbar
      v-model="successMessage"
      :timeout="3000"
      outlined
      color="success"
    >
      <v-icon color="success">mdi-check-circle</v-icon>
      <span class="mx-2">Profil modifié !</span>
    </v-snackbar>
  </div>
</template>

<script>
import format from "date-fns/format";
import LogOutButton from "@/components/LogOutButton.vue";
import store from "@/store/index.js";

export default {
  data() {
    return {
      menu: false,
      dialog: false,
      loading: false,
      successMessage: false,
      firstName: this.$store.state.user.userData.firstName,
      name: this.$store.state.user.userData.name,
      email: this.$store.state.user.userData.email,
      nickname: this.$store.state.user.userData.nickname
    };
  },
  components: {
    LogOutButton
  },
  computed: {
    creationDate() {
      const creationDateFromAuth = store.state.userMetadata.creationTime;
      // Fri, 25 Sep 2020 08:12:00 GMT
      return format(new Date(creationDateFromAuth), "dd/MM/yyyy");
    }
  },
  methods: {
    cancelModifications() {
      this.firstName = this.$store.state.user.userData.firstName;
      this.name = this.$store.state.user.userData.name;
      this.email = this.$store.state.user.userData.email;
      this.nickname = this.$store.state.user.userData.nickname;
      this.dialog = false;
      this.menu = false;
    },
    modifyProfile() {
      this.loading = true;
      this.$store.dispatch("modifyProfile", {
        userId: this.$store.state.user.userId,
        firstName: this.firstName,
        name: this.name,
        nickname: this.nickname
      });
      setTimeout(() => {
        this.loading = false;
        this.dialog = false;
        this.menu = false;
        this.successMessage = true;
      }, 1000);
    }
  }
};
</script>